// Stringify a JSON-LD payload safely for inlining inside <script type="application/ld+json">.
// Escapes "<" so a stray "</script>" inside user-authored content can't terminate the tag.
export function safeJsonLd(obj) {
  return JSON.stringify(obj).replace(/</g, "\\u003c");
}

// "YYYY-MM-DD" → full ISO 8601 ("2026-05-18T00:00:00.000Z"). Returns undefined on bad input.
export function toIsoDate(dateStr) {
  if (!dateStr) return undefined;
  const d = new Date(dateStr);
  return isNaN(d.getTime()) ? undefined : d.toISOString();
}
